const app = {
  namespaced: true,
  state: {
    lang: 'zh-CN',
    appInfo: {},
    // 系统时间相关
    timeInfo: {
      // 当前日期 yyyy-MM-DD
      date: '2021-12-17'
    }
  },
  mutations: {
    SET_LANG (state, lang) {
      state.lang = lang
    },
    SAVE_APP_INFO (state, info) {
      state.appInfo = info
    },
    SET_TIME_INFO (state, info) {
      state.timeInfo = Object.assign({}, state.timeInfo, info)
    }
  },
  actions: {
  }
}

export default app
